module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1"
  }, [_c('span', [_vm._v("Blurb")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_c('i', [_vm._v("He’s dangerous.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("He came into my life when I was sixteen. Tattooed, ear pierced, ripped jeans and bloody knuckled. That was the day his family moved in next door.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("For six years, I’ve watched my bad-boy neighbor, never knowing when he’s going to be there and when he isn’t. Never knowing what he’s doing when he’s absent, only that it’s dangerous.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("And then one night I wake to find him in my bed. Naked. Bruised and bleeding. And hard. "), _c('i', [_vm._v("Really")]), _vm._v(" hard.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("He wants me. And he knows I want him too. But he’s dangerous. On every freaking level.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Oh boy, this is going to end in pain…")]), _vm._v(" "), _c('h2', {
    staticClass: "P_Heading_2"
  }, [_c('span', [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("For Heidi, my earlier riser and coffee drinker.")]), _vm._v(" "), _c('h2', {
    staticClass: "P_Heading_2"
  }, [_c('span', [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Body_Text"
  }, [_vm._v("Cover art: Valerie Tibbs, Tibbs Design")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 66
// module chunks = 0